import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Callout, Column, ConfirmationModal, CopyField } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import styles from './CopyAPIKeyModal.module.scss';
export const GetCopyAPIKeyModalTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            CopyAPIKeyModalTID: {
                Modal: 'copy-api-key-modal',
                Button: 'copy-api-key-button',
                Callout: 'copy-api-key-callout'
            }
        }
    });
export const CopyAPIKeyModal = (param)=>{
    let { apiKeyName, apiKeyValue, dismissModal } = param;
    const { t: apiKeysPageTexts } = useLocaleKeys('settings.apiKeys');
    const { t: commonTexts } = useLocaleKeys('common');
    const { CopyAPIKeyModalTID } = useMemo(()=>GetCopyAPIKeyModalTID(), []);
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        bi: {
            primaryButton: {
                name: 'copy_a_p_i_key_confirm'
            },
            secondaryButton: {
                name: 'copy_a_p_i_key_cancel'
            }
        },
        title: apiKeysPageTexts.apiKeyTitle({
            keyName: apiKeyName
        }),
        testId: CopyAPIKeyModalTID.Modal(),
        width: "640px",
        content: /*#__PURE__*/ _jsxs(Column, {
            className: styles.container,
            children: [
                /*#__PURE__*/ _jsx(CopyField, {
                    value: apiKeyValue,
                    testId: CopyAPIKeyModalTID.Button(),
                    bi: {
                        name: 'copy_api_key'
                    }
                }),
                /*#__PURE__*/ _jsx(Callout, {
                    testId: CopyAPIKeyModalTID.Callout(),
                    children: apiKeysPageTexts.copyCallout()
                })
            ]
        }),
        primaryButtonLabel: commonTexts.buttons.close(),
        onPrimaryButtonClick: dismissModal,
        onCloseButtonClick: dismissModal
    });
};
